import { gettext } from '@adjust/dashboard-core/lib/utils/localization';

let shortKpis = [
  gettext('kpi.limit_ad_tracking_install_rate_short'),
  gettext('kpi.rejected_installs_anon_ip_short'),
  gettext('kpi.rejected_installs_too_many_engagements_short'),
  gettext('kpi.rejected_installs_distribution_outlier_short'),
  gettext('kpi.rejected_installs_click_injection_short'),
  gettext('kpi.rejected_reattributions_anon_ip_short'),
  gettext('kpi.rejected_reattributions_too_many_engagements_short'),
  gettext('kpi.rejected_reattributions_distribution_outlier_short'),
  gettext('kpi.rejected_reattributions_click_injection_short'),
  gettext('kpi.rejected_installs_invalid_signature_short'),
  gettext('kpi.ecpi_short'),
  gettext('kpi.ecpc_short'),
  gettext('kpi.ecpm_short'),
  gettext('kpi.return_on_investment_short'),
  gettext('kpi.rcr_short'),
  gettext('kpi.ad_rpm_short'),
  gettext('kpi.all_revenue_short'),
  gettext('kpi.roas_short')
];

export { shortKpis };
